// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2koA8{padding:1rem;display:-ms-inline-flexbox;display:inline-flex;cursor:pointer;-ms-flex-align:center;align-items:center;color:#0373f9;background-color:#fff;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);border:1px solid #0373f9;border-radius:.25rem}._3sEyC path[fill]{fill:#0373f9}._1-QKf{-ms-flex:0 0 24px;flex:0 0 24px;-ms-flex:0 0 1.5rem;flex:0 0 1.5rem}._3e3d6{margin-left:.75rem;margin-right:auto;-ms-flex-positive:0;flex-grow:0;display:block;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}._21Abx{background-color:#dcdddd;border:none;color:#fff;pointer-events:none}._21Abx path[fill]{fill:#fff}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_2koA8",
	"materialIcon": "_3sEyC",
	"icon": "_1-QKf",
	"title": "_3e3d6",
	"disabled": "_21Abx"
};
module.exports = exports;
